import columns from './statistics-columns';

export default () => ({
    columns: [
        columns.processor,
        columns.processor_number,
        columns.processor_city,
        columns.processor_state,
        columns.category,
        columns.amount,
        { ...columns.fat_weight, headerName: 'BF (lbs)' },
        { ...columns.protein_weight, headerName: 'PR (lbs)' },
        { ...columns.skim_weight, headerName: 'SKIM (lbs)' },
        columns.other_solids_weight,
        { ...columns.fat_average, headerName: 'BF (%)' },
        { ...columns.protein_average, headerName: 'PR (%)' },
        columns.other_solids_average,
        // Wrap
    ],
});
